<div *ngIf="languaje === 'en'">
	<li class="pill" [ngClass]="{'active': is_active}">
		<a href="https://usa.visa.com/legal/privacy-policy.html/" target="_blank"  class="icon-Combined-Shape-4">Privacy Notice</a>
	</li>
		
	<a href="https://usa.visa.com/legal/privacy-policy.html/" target="_blank" class="icon-Combined-Shape-4 pill-mobile" [ngClass]="{'active': show_mobile}">Privacy Notice</a>  
</div>



<div *ngIf="languaje === 'es'">
	<li class="pill" [ngClass]="{'active': is_active}">
		<a href="https://www.visa.es/terminos-de-uso/centro-de-privacidad-de-visa.html" target="_blank"  class="icon-Combined-Shape-4">Aviso de Privacidad</a>
	</li>
		
	<a href="https://www.visa.es/terminos-de-uso/centro-de-privacidad-de-visa.html" target="_blank"  class="icon-Combined-Shape-4 pill-mobile" [ngClass]="{'active': show_mobile}">Aviso de Privacidad</a>
</div>
